Ext.define('SA.ScarboroughCrosstabEditController', {
    constructor({model, activeState}) {
        this.model = model;
        this.activeState = activeState;

        this.modelLocations = new SA.EditModelLocations(model);
        this.modelAttributes = new SA.EditModelAttributes(model);

        this.validator = SA.EditValidator.forModel(this.model);
        this.validator.addRuleType(SA.EditCrosstabAttributesRequiredRule);
        this.validator.addRuleType(SA.EditCrosstabMaximumAttributesRule);

        this.locationsPanel = SA.EditPanelBuilder.forLocations().withRadios().build();

        this.attributesPanel = SA.EditPanelBuilder
            .forAttributes()
            .withSelectionButtons()
            .setSubheader(SA.CrosstabAttributesPanelSubheader.create())
            .setItemFactory(id => Ext.widget({xtype: 'crosstab-attributes-panel-item', dataId: id}))
            .addDisabledSection({sectionId: 'excluded-by-dma', message: 'These variables are not supported by the selected DMA'})
            .addDisabledSection({sectionId: 'not-excluded-by-dma', message: 'These variables are not supported by this view type'})
            .build();

        this.view = Ext.widget({xtype: 'edit-view', panels: [this.locationsPanel.getView(), this.attributesPanel.getView()]});
        this.selectLocationMessage = this.view.add({xtype: 'scarborough-crosstab-edit-select-location-message'});

        this.initEvents();
    },

    initEvents() {
        this.modelObserver = SA.EditModelObserver.create(this.model, this.refresh, this);
        this.modelObserver.observeName();
        this.modelObserver.observeLocations();
        this.modelObserver.observeAttributes();

        this.activeState.onActive(this.refresh, this);
        this.activeState.onChange(active => this.modelObserver.setEnabled(active));

        this.sidebarObserver = new SA.SidebarObserver(this.activeState);
        this.sidebarObserver.onUseLocation(this.onSidebarUseLocation, this);
        this.sidebarObserver.onUseAttribute(this.onSidebarUseAttribute, this);

        this.view.onDoneClick(() => SA.AppController.showProjectView(this.model));

        this.attributesPanel.onSelectAllClick(() => this.model.addProjectAttributes());
        this.attributesPanel.onClearClick(() => this.model.clearAttributes());
        this.attributesPanel.onItemChange(this.onAttributesPanelItemChange, this);
    },

    getView() {
        return this.view;
    },

    onAttributesPanelItemChange({attribute, state}) {
        var side = {top: state.column, left: state.row};

        this.model.toggleAttribute({attribute, side});
    },

    onSidebarUseAttribute(id) {
        this.view.scrollToEl(() => this.attributesPanel.getEnabledItemEl(id));
    },

    onSidebarUseLocation(id) {
        this.view.scrollToEl(() => this.locationsPanel.getEnabledItemEl(id));
    },

    refresh() {
        var hasLocation = this.model.hasLocation(),
            supportedTabs = SA.controller.ScarboroughCrosstabController.getSupportedTabs(this.model);

        SA.Sidebar.setEnabledTabs(supportedTabs);

        if (supportedTabs.length === 1) {
            SA.Sidebar.setSelectedTab(supportedTabs[0]);
        }

        this.selectLocationMessage.setVisible(!hasLocation);
        this.view.setHeaderVisible(hasLocation);
        this.view.setSectionsVisible(hasLocation);

        if (!hasLocation) {
            return;
        }

        this.view.setViewName(this.model.getName());
        this.view.setWarningMessage(this.validator.getFirstMessage());

        this.locationsPanel
            .setEnabledIds(this.model.getLocations())
            .setDisabledIds(this.model.getProjectLocations().filter(location => !SA.data.LocationsCache.isDMA(location)))
            .eachItem(item => item.refreshLabel())
            .eachEnabledItem(radio => radio.setCheckedSuppressed(this.modelLocations.isSelected(radio.getDataId())));

        this.attributesPanel
            .setEnabledIds(this.modelAttributes.getSupported())
            .eachEnabledItem(item => {
                var isRowAttribute = this.model.getAttributesModel().has({left: item.getDataId()}),
                    isColumnAttribute = this.model.getAttributesModel().has({top: item.getDataId()});

                item.setState({row: isRowAttribute, column: isColumnAttribute});
            });

        this.attributesPanel
            .getDisabledSectionById('excluded-by-dma')
            .setIds(this.modelAttributes.filterUnsupported(attribute => this.model.isAttributeExcludedByDMA(attribute)));

        this.attributesPanel
            .getDisabledSectionById('not-excluded-by-dma')
            .setIds(this.modelAttributes.filterUnsupported(attribute => !this.model.isAttributeExcludedByDMA(attribute)));
    }
});